import React from 'react';
import NoProductImg from './images/NoProduct.svg';
import noImg from '../../assets/no-itm.png';
import css from './index.module.scss';
import { FormattedMessage } from 'react-intl';

function SearchEmptyContainer() {
  return (
    <div className={css.searchEmptyContainer}>
      <img
        src={NoProductImg}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = noImg;
        }}
        alt="No Products Found"
      />
      <span className={css.line1}>
        <FormattedMessage id="whats_your_pick" defaultMessage="What's your pick?" />
      </span>
      <span className={css.line2}>
        <FormattedMessage
          id="now_discover_our_menu_based_on_your_search_preferences"
          defaultMessage="Now discover our menu based on your search preferences!"
        />
      </span>
    </div>
  );
}

export default SearchEmptyContainer;
